import type { AegisOptionValue } from '@move-right/aegis/core/documentOptions';
import { createActionGroup, emptyProps, props } from '@ngrx/store';


import { BaseArtifactFragment } from '../../../generated/graphql.generated';
import { ActionSource } from '../../state/action-sources';

import { AegisDocumentPreview, CreateDocumentDialogInput, CreateDocumentSubmission } from './create-document-dialog.state';

export const CreateDocumentDialogActions = createActionGroup({
  source: ActionSource.CREATE_DOCUMENT_DIALOG,
  events: {
    'Dialog Opened': props<CreateDocumentDialogInput>(),
    'Job Actions Create Document Clicked': props<{ jobId: string }>(),
    'Send Receipt Button Clicked': props<{ jobId: string; transactionIds?: string[] }>(),

    'Dialog Closed': emptyProps(),
    'Document Checkbox Clicked': props<{ docType: string }>(),
    'Document Row Clicked': props<{ docType: string }>(),
    'Preview Button Clicked': props<{ docType: string }>(),
    'Needs Attention Link Clicked': props<{ docType: string }>(),
    'Previous Document Button Clicked': props<{ docType: string }>(),
    'Next Document Button Clicked': props<{ docType: string }>(),
    'Retry Preview Button Clicked': props<{ docType: string }>(),
    'Preview Loaded': props<{ session: number; preview: AegisDocumentPreview }>(),
    'Preview Failed': props<{ session: number; docType: string; error: Error }>(),

    'Option Changed': props<{ name: string; value: AegisOptionValue | undefined }>(),
    'Message Changed': props<{ message: string }>(),

    'Submit Button Clicked': props<{ submission: CreateDocumentSubmission }>(),
    'Create Without Sending Menu Item Clicked': emptyProps(),
    'Document Created': props<{
      session: number;
      jobId: string;
      docType: string;
      artifact: BaseArtifactFragment;
      sent: boolean;
      sendError?: string;
    }>(),
    'Create Document Failed': props<{ session: number; docType: string; error: Error }>(),

    'Try Creating Again Button Clicked': props<{ docType: string }>(),
    'Try Sending Again Button Clicked': props<{ docType: string }>(),
    'Resend Succeeded': props<{ session: number; jobId: string; docType: string; artifactId: string }>(),
    'Resend Failed': props<{ session: number; docType: string; error: Error }>(),

    'Download Button Clicked': props<{ docType: string }>(),
    'Create Invoice Link Clicked': emptyProps(),
  },
});
